module.exports = __webpack_public_path__ + "img/growthAbility3.f4d8349f.png";